<template>
<div id="Register" class="">
  <b-container fluid>
    <b-row>
      <!-- <b-col md="4" class="text-white bg-dark">2 of 2</b-col> -->
      <b-col md="7" lg="5" class="form-login mx-auto mb-3">
        <b-card class="mb-1 animate__animated animate__fadeInDown" footer-class="text-center">
          <b-card-body class="text-center align-items-center h2">
            <b-img :src="logoImg" width="100px" class="rounded-circle"></b-img>
            {{ logoName }}
          </b-card-body>

          <b-card-body>
            <div class="text-center" v-if="!dataReady">
              <b-spinner style="width: 3rem; height: 3rem;" label="Loading..." variant="info"></b-spinner>
            </div>
            <template v-if="dataReady">
              <b-card-text>
                <label for="form_username" class="mb-1">Username:</label>
                <b-form-input id="form_username" autocomplete="off" class="mb-2" v-model="form.userName" type="text" ></b-form-input>
                <label for="form_password" class="mb-1">Password:</label>
                <b-form-input id="form_password" autocomplete="off" :state="passwordState" aria-describedby="password-feedback" class="mb-2" v-model="form.password" type="password"></b-form-input>
                <b-form-invalid-feedback id="password-feedback">
                  รหัสผ่านต้องมีจำนวนมากกว่า 8 ตัวอักษร
                </b-form-invalid-feedback>

                <label for="form_confirmpassword" class="mb-1">Confirm password:</label>
                <b-form-input id="form_confirmpassword" autocomplete="off" :state="confirmState" aria-describedby="confirm-feedback" class="mb-2" v-model="passwordConfirm" type="password"></b-form-input>
                <b-form-invalid-feedback id="confirm-feedback">
                  ยืนยันรหัสผ่านต้องเหมือนกัน
                </b-form-invalid-feedback>

                <label for="form_firstname" class="mb-1">First name:</label>
                <b-form-input id="form_firstname" autocomplete="off" class="mb-2" v-model="form.firstName" type="text" ></b-form-input>
                <label for="form_lastname" class="mb-1">Last name:</label>
                <b-form-input id="form_lastname" autocomplete="off" class="mb-2" v-model="form.lastName" type="text" ></b-form-input>
                <label for="form_tel" class="mb-1">Tel:</label>
                <b-form-input id="form_tel" autocomplete="off" class="mb-2" v-model="form.telephoneNumber" type="tel" maxlength="10"></b-form-input>
                <label for="form_address" class="mb-1">Address:</label>
                <b-form-textarea id="form_address" autocomplete="off" class="mb-2" v-model="form.address" type="text" ></b-form-textarea>
              </b-card-text>
              <b-button variant="success" @click="registerUser" block pill>Create an account</b-button>
            </template>
          </b-card-body>
        </b-card>
        <br>
        <b-button variant="primary" pill @click="loginUser" block>Already have an account? <strong>Log in</strong></b-button>
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
import axios from 'axios' // api
export default {
  name: 'LineRegister',
  beforeCreate () {
    // เหตุการจะเกิดขึ้นก่อนที่ Component จะถูก render เข้าไปใน DOM
    // this.$liff.init({ liffId: this.$liff_register_profile }, function (data) {})
    // document.body.className = 'login';
  },
  created () {
    // ทุกอย่างจะถูกเตรียมไว้ครบหมดแล้ว และสามารถเข้าถึงได้หมด
  },
  async mounted () {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น
    // await this.getDataUser("tester")
  },
  computed: {
      passwordState () {
        return this.form.password.length >= 8
      },
      confirmState () {
        return this.passwordConfirm.length >= 8 && this.passwordConfirm === this.form.password
      }
  },
  data () {
    return {
      msg: 'Welcome Kathin',
      dataReady: true,
      passwordConfirm: '',
      form: {
        userCode: '',
        userName: '',
        password: '',
        firstName: '',
        lastName: '',
        telephoneNumber: '',
        address: '',
        userType: 'U',
        CREATE_USER: 'SYS_REGISTER'
      }
    }
  },
  methods: {
    registerUser () {
      axios
        .post(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/User/user_add",
          this.form,
          {
            headers: this.getHeaderAPI('User_add', this.form.userName)
          }
        )
        .then(async (response) => {
          // console.log('registerUser', response)
          let rs = response.data
          if (rs.status === true) {
            this.$swal("สำเร็จ","ลงทะเบียนบัญชีผู้ใช้เรียบร้อย","success")
              .then((result) => {
                this.$router.push('/Login')
              })
          } else {
            // console.log('registerUser Fail')
            if (rs.message === 'Duplicate username') {
              this.$swal("ผิดพลาด","พบว่า Username ซ้ำ","error")
            } else {
              this.$swal("ผิดพลาด","ไม่สามารถสร้างบัญชีผู้ใช้ได้","error")
            }
            // this.dataReady = true
          }
          this.dataReady = true
        })
        .catch((error) => {
          console.log(error.response)
          let codeStatus = ''
          if (error.response.status) { codeStatus = ' (CS' + error.response.status + ') ' }
          this.$swal("ผิดพลาด","ระบบมีปัญหาในการสร้างบัญชีผู้ใช้ ("+codeStatus+")","error")
          this.dataReady = true
        })
    },
    loginUser () {
      this.$router.push('/oa/login')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-login{
  margin-top: 60px;
}
label{
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/LineOA/LineRegister.vue